
        var result = require("!!../../../../node_modules/css-loader/index.js!./document-admin-form.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/document-admin-form/document-admin-form.component.css
// module id = 589
// module chunks = 0